
export const loadVippsCheckoutSDK = () => {
    const script = document.createElement('script');
    script.src = 'https://checkout.vipps.no/vippsCheckoutSDK.js';
    script.async = true;
    document.body.appendChild(script);
};
